import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const horizontalBarGraphDescription: CalculatorDescription = {
  id: CalculatorId.HorizontalBarGraph,
  title: 'Horizontal Bar Chart Maker',
  metaTitle: 'Free Online Horizontal Bar Chart Maker - Create Horizontal Bar Graphs',
  description: 'Create professional horizontal bar charts easily with our free online tool. Perfect for comparing categories with long labels, ranking data, or displaying survey results.',
  metaDescription: 'Make horizontal bar charts online. Easy-to-use, free tool for creating professional bar graphs. Compare data, show rankings, and visualize statistics horizontally.',
  howTo: {
    title: 'How to Create a Horizontal Bar Chart',
    steps: [
      'Enter your data categories and values',
      'Customize colors and labels',
      'Add a title and axis labels',
      'Adjust bar spacing and width',
      'Download or share your chart'
    ],
    graphic: {
      description: 'An echarts horizontal bar chart showing sample categories and values, with a shadcn form for data input'
    }
  },
  examples: [
    {
      title: 'Survey Results',
      description: 'Response distribution for a customer satisfaction survey',
      dataDescription: 'Shows satisfaction levels across different service aspects',
      insights: [
        'Long category labels are clearly readable',
        'Easy to compare satisfaction scores',
        'Visual ranking of service aspects',
        'Clear display of response distribution'
      ]
    },
    {
      title: 'Population Rankings',
      description: 'City population comparison',
      dataDescription: 'Population data for major cities',
      insights: [
        'Easy to read city names',
        'Quick visual comparison of values',
        'Clear population ranking',
        'Effective for long location names'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BarGraph,
    CalculatorId.StackedBarChart,
    CalculatorId.PieChart
  ]
}; 